import { useState } from 'react';
import { Form, Input, InputNumber, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { NotificationType } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';
import { errorTypes } from '../../../models/enums/error-type';

export function NotificationEditPage(props: {
  notification?: NotificationType;
  onSaved: (notification?: NotificationType) => void;
  onCancel: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.notification) {
      apiClient
        .post('notifications', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`notifications/${props.notification?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.notification}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Öncelik puanı" name="priorityScore" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item label="Hata türü" name={'errorType'} rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select>
          <Select.Option key={'INTERNAL'} value={'INTERNAL'}>
            {errorTypes.get('INTERNAL')}
          </Select.Option>
          <Select.Option key={'EXTERNAL'} value={'EXTERNAL'}>
            {errorTypes.get('EXTERNAL')}
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
